export const PATENT_QUERY_KEYS = {
  patentListFilter: "patentListFilter",
};
